import i18n from 'i18next';

export default ({ params, topicTitle, flattenedVideosAdminTree }) => {
  const rootUrl = `/videos/organizations/${params.orgId}/${params.type}`;

  const breadcrumbsArray = [
    {
      text: i18n.t('videos'),
      path: rootUrl,
      key: 'mainVideosPath',
    },
  ];

  const { id } = params;

  const currentTopic = flattenedVideosAdminTree.data?.find((topic) => topic.id === Number(id));

  currentTopic?.ancestry?.forEach(({ id: itemId, name }) => {
    breadcrumbsArray.push({
      text: name,
      path: `${rootUrl}/topics/${itemId}`,
      key: `flattenedVideosAdminTree-${itemId}`,
    });
  });

  return [...breadcrumbsArray, { text: topicTitle, path: '', key: `breadcrumbTopic-${params.id}` }];
};
